<template>
  <v-card class="mt-4">
    <v-card-text>
      <div class="d-flex align-center">
        <div
          :class="{
            'text-indigo-medium': disabledQuarantineFolder,
          }"
          class="subtitle1 mb-1"
        >
          {{ $t("emailSettings.settingsTab.quarantineFolder") }}
        </div>
        <v-tooltip v-if="disabledQuarantineFolder" open-delay="300" location="top">
          <template #activator="{ props }">
            <v-icon icon="$info" v-bind="props" />
          </template>
          <span>{{ $t("emailSettings.settingsTab.quarantineFolderInfoTooltip") }}</span>
        </v-tooltip>
      </div>
      <div class="body2 text-indigo-medium mb-3">
        {{ $t("emailSettings.settingsTab.quarantineFolderDescription") }}
      </div>
      <v-radio-group v-model="localValue.quarantineFolder">
        <v-radio
          v-for="folder in folders"
          :key="folder"
          :disabled="disabledQuarantineFolder"
          :value="folder"
        >
          <template #label>
            <div class="body2">
              {{ $t(`emailSettings.settingsTab.quarantineFolderType.${folder}`) }}
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, toRefs } from "vue";
import type { EmailSecuritySettings } from "@/_store/email-security/email-settings.module.ts";
import { QuarantineFolder } from "@/constants/emails.ts";
import { useSecurityAwarenessEmptyState } from "@/composables/useSecurityAwarenessEmptyState.ts";
import { useEmailProxyStore } from "@/_store/email-security/email-proxy.module.ts";
import { storeToRefs } from "pinia";

import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<EmailSecuritySettings>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    actionNotAllowed: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const emailProxyStore = useEmailProxyStore();
    const { isCloudAppsConnected } = useSecurityAwarenessEmptyState();
    const { isProxyActive } = storeToRefs(emailProxyStore);

    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value) => {
      emit("update:modelValue", value);
    });

    const disabledQuarantineFolder = computed(() => {
      return (
        props.disabled ||
        props.actionNotAllowed ||
        (!isCloudAppsConnected.value && isProxyActive.value)
      );
    });

    return {
      localValue,
      disabledQuarantineFolder,
      folders: [QuarantineFolder.SUSPECTED, QuarantineFolder.TRASH],
    };
  },
});
</script>
